import {
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  FunctionField,
  List,
  Filter,
  TextField,
  useTranslate,
  DeleteButton,
  EditButton,
  useNotify,
  useRedirect,
  useRefresh,
  TextInput,
  DateInput,
  SelectInput,
  useListController,
  EmailField,
} from 'react-admin';
import { DashboardContent } from 'src/layouts/dashboard';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import { Resources } from '../resource';
// 导入数据提供者初始化
import './init';
import FilterGroup from 'src/pages/admin/components/FilterGroup';
import { Card, Dialog, Stack } from '@mui/material';
import { ReactElement, useState } from 'react';
import CreateInviteCode from './mutations/Create';
import EditInviteCode from './mutations/Edit';
import AddressField from '../../components/AddressField';
import XTextField from '../../components/XTextField';
const ListFilter = (props: any) => {
  return (
    <div style={{ position: 'relative' }}>
      <Filter {...(props || {})}>
        <FilterGroup alwaysOn spacing={0} p={0}>
          <FilterGroup>
            <TextInput source="userId" label="userId" />
            <TextInput source="code" label="code" />
          </FilterGroup>
        </FilterGroup>
      </Filter>
    </div>
  );
};

const View = () => {
  const translate = useTranslate();
  const redirect = useRedirect();
  const [popup, setPopup] = useState<ReactElement>();
  const notify = useNotify();

  return (
    <PermissionGuard resource="invite-codes" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={translate('resource.inviteCodes')}
          links={[
            { name: translate('resource.inviteCodes') },
            { name: translate('resource.inviteCodesItem') },
          ]}
          action={
            <PermissionGuard resource="invite-codes" action="create" fallback={<></>}>
              <CreateButton
                variant="contained"
                size="medium"
                onClick={(e) => {
                  e.preventDefault();
                  setPopup(<CreateInviteCode onClose={() => setPopup(undefined)} />);
                }}
              />
            </PermissionGuard>
          }
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List
            actions={false}
            empty={false}
            perPage={10}
            exporter={false}
            filters={<ListFilter />}
          >
            {/* <FilterFormInput /> */}
            <Datagrid rowClick={false}>
              <TextField source="userId" label="UserId" />
              <FunctionField
                label="Login as"
                render={(record: any) => (
                 record.loginAs?.email ? <XTextField text={record.loginAs?.email} sx={{width: "150px"}}/> : <AddressField address={record.loginAs?.userAddress} sx={{width: "150px"}}/>
                )}
              />
              <TextField source="code" label="Code" />
              <TextField source="verified" label="Verified" />
              <FunctionField
                label="Actions"
                render={(record: any) => (
                  <Stack direction="row" spacing={2}>
                    <PermissionGuard resource="invite-codes" action="update" fallback={<></>}>
                      <EditButton
                        onClick={(e) => {
                          e.preventDefault();
                          setPopup(
                            <EditInviteCode
                              id={record.code}
                              resource={record}
                              onClose={() => setPopup(undefined)}
                            />
                          );
                        }}
                      />
                    </PermissionGuard>
                  </Stack>
                )}
              />
            </Datagrid>
          </List>
        </Card>

        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog>
      </DashboardContent>
    </PermissionGuard>
  );
};

export default View;
